// extracted by mini-css-extract-plugin
export default {"Select":"select_Select__Vc-yX"};